import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getComponentElements } from '../utils.js';
export default class ChildrenManager {
  get registeredNames() {
    return Object.keys(this).filter(key => !key.startsWith('__'));
  }

  constructor(base, element, components, eventsManager) {
    _defineProperty(this, "__base", void 0);

    _defineProperty(this, "__element", void 0);

    _defineProperty(this, "__components", void 0);

    _defineProperty(this, "__eventsManager", void 0);

    Object.defineProperties(this, {
      __base: {
        enumerable: false,
        writable: false,
        value: base
      },
      __element: {
        enumerable: false,
        writable: false,
        value: element
      },
      __components: {
        enumerable: false,
        writable: false,
        value: components
      },
      __eventsManager: {
        enumerable: false,
        writable: false,
        value: eventsManager
      }
    });
  }

  registerAll() {
    Object.entries(this.__components).forEach(_ref => {
      var [name, component] = _ref;
      return this.__register(name, component);
    });
  }

  __register(name, component) {
    Object.defineProperty(this, name, {
      enumerable: true,
      configurable: true,
      get: () => {
        var elements = getComponentElements(name, this.__element);

        if (elements.length === 0) {
          return [];
        }

        return elements.map(element => this.__getChild(element, component, name)).filter(instance => instance !== 'terminated');
      }
    });
  }

  __getChild(el, ComponentClass, name) {
    if (el.__base__) {
      return el.__base__;
    }

    if ('$isBase' in ComponentClass) {
      var child = new ComponentClass(el);
      Object.defineProperty(child, '$parent', {
        get: () => this.__base
      });
      return child;
    }

    return ComponentClass(this.__base).then(module => {
      var _module$default;

      return this.__getChild(el, (_module$default = module.default) !== null && _module$default !== void 0 ? _module$default : module, name);
    });
  }

  mountAll() {
    this.__triggerHookForAll('$mount');
  }

  updateAll() {
    this.__triggerHookForAll('$update');
  }

  destroyAll() {
    this.__triggerHookForAll('$destroy');
  }

  __triggerHookForAll(hook) {
    this.registeredNames.forEach(name => {
      this[name].forEach(instance => {
        if (instance instanceof Promise) {
          instance.then(resolvedInstance => this.__triggerHook(hook, resolvedInstance, name));
        } else {
          this.__triggerHook(hook, instance, name);
        }
      });
    });
  }

  __triggerHook(hook, instance, name) {
    if (hook === '$update' && !instance.$isMounted) {
      hook = '$mount';
    }

    if (hook === '$update' || hook === '$destroy') {
      this.__eventsManager.unbindChild(name, instance);
    }

    if (hook === '$update' || hook === '$mount') {
      this.__eventsManager.bindChild(name, instance);
    }

    instance[hook]();
  }

}